// extracted by mini-css-extract-plugin
export default {"card":"VerticalsLca_card__rsxm-","verticalslogo":"VerticalsLca_verticalslogo__M5Icd"};